module.exports = __webpack_public_path__ + "static/media/SherlockBonesSeaCreatureBookCover.e2957033.jpg";